import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { CustomTableReport } from 'src/app/interfaces/custom-table-report/custom-table-report.interface';
import { AuditFilterModel } from 'src/app/models/audit/audit-filter.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TransactionsByCompanyService {

  constructor(private _httpClient: HttpClient) { }

  exportTransactionsByCompany(auditFilterModel: AuditFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.transactionsByCompany.ExportTransactionsByCompany}`, auditFilterModel, {
      responseType: 'blob',
    });
  }

  exportTransactionsByUserAutheticated(auditFilterModel: AuditFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.transactionsByCompany.ExportTransactionsByUserAutheticated}`, auditFilterModel, {
      responseType: 'blob',
    });
  }

  getTransactionsByCompany(auditFilterModel: AuditFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transactionsByCompany.GetTransactionsByCompany}`,
      auditFilterModel);
  }

  getTransactionsByUserAutheticated(auditFilterModel: AuditFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transactionsByCompany.GetTransactionsByUserAutheticated}`,
      auditFilterModel);
  }
}
